module.exports = __webpack_public_path__ + "media/images/landkit/screenshots/landkit/landing/coworking-e2e338e09c8967f5e2e93230cd09cf7b.jpg";